module.exports = __webpack_public_path__ + "img/clube2.f54b2155.jpeg";